import translations from '../localization/translations';

const USER_TYPE_KEYS = {
  doctor: 'userTypes.doctor',
  technician: 'userTypes.technician',
  courier: 'userTypes.courier',
  admin: 'userTypes.admin',
};

const DELIVERY_TYPE_SLUG_KEYS = {
  'standard-delivery': 'deliveryTypes.standard_delivery',
  'free-delivery': 'deliveryTypes.free_delivery',
};

const lookupTranslation = (key, language, fallback) =>
  translations[language]?.[key] ?? translations.en?.[key] ?? fallback;

export const translateUserTypeName = (name, language = 'ar') => {
  if (name === null || name === undefined || name === '') {
    return name ?? '';
  }

  const slug = String(name).trim().toLowerCase();
  const key = USER_TYPE_KEYS[slug];

  return key ? lookupTranslation(key, language, name) : name;
};

export const translateDeliveryTypeName = (value, language = 'ar') => {
  if (value === null || value === undefined || value === '') {
    return value ?? '';
  }

  let name = null;
  let slug = null;

  if (typeof value === 'string') {
    name = value;
  } else if (typeof value === 'object') {
    name = value.name ?? null;
    slug = value.slug ?? null;
  }

  const slugCandidates = [];
  if (slug) {
    slugCandidates.push(String(slug).trim().toLowerCase());
  }
  if (name) {
    slugCandidates.push(String(name).trim().toLowerCase().replace(/\s+/g, '-'));
  }

  for (const candidate of slugCandidates) {
    const key = DELIVERY_TYPE_SLUG_KEYS[candidate];
    if (key) {
      return lookupTranslation(key, language, name ?? slug);
    }
  }

  return name ?? slug ?? value;
};

export const getDateRangePlaceholder = (language = 'ar') => [
  lookupTranslation('ui.date.startDate', language, 'Start Date'),
  lookupTranslation('ui.date.endDate', language, 'End Date'),
];
